import React from "react";
import MonthDropdown from "./month";
import YearDropdown from "./year";
import { getValue } from "@utils/lodash";
import { convertDate } from "@_common/date-helpers";

function CalenderDropdown(props) {
  const { isApplyButtonRequied } = props;
  let month = getValue(props, `value`, "")
    ? convertDate(
        getValue(props, `value`, "")
          ? getValue(props, `value`, "")
          : new Date(),
      ).split("-")[1]
    : "";
  let year = getValue(props, `value`, "")
    ? convertDate(
        getValue(props, `value`, "")
          ? getValue(props, `value`, "")
          : new Date(),
      ).split("-")[0]
    : "";

  const handleSelectMonth = (value) => {
    if (getValue(value, "value") && year) {
      let date = `${year}-${getValue(value, "value")}-01`;
      props.onChange(new Date(date));
    }
  };

  const handleSelectYear = (value) => {
    if (getValue(value, "value") && year) {
      let date = `${getValue(value, "value")}-${month}-01`;
      props.onChange(new Date(date));
    }
  };

  return (
    <div className="d-flex">
      {props.isYear && (
        <MonthDropdown value={month} handleSelectDate={handleSelectMonth} />
      )}
      <YearDropdown value={year} handleSelectDate={handleSelectYear} />

      {isApplyButtonRequied && (
        <button
          className="calender-button"
          onClick={props.handleSubmitDate}
          disabled={props.disableDate}
        >
          Apply
        </button>
      )}
    </div>
  );
}

export default CalenderDropdown;
